import PrivacyPromise from 'components/pages/PrivacyNotice/PrivacyNotice';
import { buildPage } from 'utils/pageHelper';
export default buildPage(PrivacyPromise, {
  metaData: {
    title: 'Privacy Notice',
    description:
      'Qmee privacy notice which governs the collection, storage and use of personal data collected by us.',
  },
});
